/* eslint-disable eqeqeq */
/* eslint-disable space-in-parens */
/* eslint-disable quotes */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Pipeline from './pipeline'
import Meeting from './meeting'
import PipelineSetting from './setting'
import store from '../store'
import NotFound from '../views/error/404.vue'
import Unauthorized from '../views/error/401.vue'
import sendMessage from '@/util/app-message/send';
import Home from '../views/Home';

Vue.use(VueRouter)

// MEETING_WEBVIEW 腾讯会议webview标识
const MEETING_WEBVIEW = 'meeting_webview';
const MEETING_WEBVIEW_TAPD_LOGIN = 'meeting_webview_tapd_login';
//云端path增加公司id
const routes = [
    { path: '/401', name: 'unauthorized', component: Unauthorized },
    { path: '/404', name: 'notFound', component: NotFound },
    {
        path: '/meeting_redirect/:from',
        name: 'meetingRedirect',
        meta: {
            type: MEETING_WEBVIEW,
            requiresAuth: true
        },
        component: () => import('@/views/meeting/redirect')
    },
    {
        path: (process.env.VUE_APP_IS_CLOUD == 1 ? '/:companyId' : '') + '/:workspaceId',
        component: () => import('@/views/Workspace'),
        children: [
            ...Pipeline,
            ...PipelineSetting,
            ...Meeting,
            {
                path: 'login',
                name: 'login',
                component: () => import('@/views/Login')
            }
        ]
    },
    {
        path: '/*',
        name: 'home',
        component: Home
    }
]


const router = new VueRouter({
    routes
});

router.beforeEach((to, from, next) => {
    if (location.href.indexOf('oauth_redirect') !== -1) {
        console.log('indexOf', location.href + ';' + to.name);
    }
    if (location.href.indexOf('oauth_redirect') !== -1 && 'home' === to.name) {
        const url = new URL(location.href);
        const nextPath = process.env.BASE_URL + '#' + url.searchParams.get("cb") + "?code=" + url.searchParams.get("code") + "&state=" + url.searchParams.get("state") + "&oauth_login=" + MEETING_WEBVIEW_TAPD_LOGIN + "&resource=" + url.searchParams.get("resource")
        console.log('indexOf nextPath', nextPath);
        location.replace(nextPath);
        return;
    }

    if (location.pathname.indexOf('oauth_redirect') !== -1) {
        console.log(location.href + ';' + to.name);
    }
    if (location.pathname.indexOf('oauth_redirect') !== -1 && 'home' === to.name) {
        const url = new URL(location.href);
        const redirect_tapd = url.searchParams.get('redirect_tapd');
        // console.log('oauth_redirect:', redirect_tapd);
        if (redirect_tapd) {
            location.href = redirect_tapd;
            return;
        }
        location.replace(process.env.BASE_URL + '#' + url.searchParams.get("cb") + "?code=" + url.searchParams.get("code") + "&state=" + url.searchParams.get("state") + "&oauth_login=" + MEETING_WEBVIEW_TAPD_LOGIN + "&resource=" + url.searchParams.get("resource"));
        return;
    }

    let type = to.meta.type ? to.meta.type : '';
    // 如果有绑定的公司和项目id
    let path = '/' + (process.env.VUE_APP_IS_CLOUD == 1 ? (to.params.companyId || 0) + '/' : '') + (to.params.workspaceId || 0) + '/login';

    if (MEETING_WEBVIEW_TAPD_LOGIN === to.query.oauth_login) {
        type = MEETING_WEBVIEW_TAPD_LOGIN
    }
    // const localStorageKeys = Object.keys(localStorage);
    // // 遍历这些键
    // localStorageKeys.forEach(function(key) {
    //     // 获取每个键对应的值
    //     const value = localStorage.getItem(key);
    //     // 打印键和值
    //     console.log('router localStorage ',key + ": " + value);
    // });

    // console.log('router info', location.href, path, to.path, JSON.stringify(to.query));
    // console.log('router info type', type);
    // console.log('router info statApiToken', store.getters.statApiToken);
    // console.log('router info apiToken', store.getters.apiToken);

    if (to.path === path) {
        next()
    } else {
        if(process.env.VUE_APP_IS_CLOUD == 1){
            // 判断是否需要使用state中的apiToken登录还是使用store.getters.apiToken登录(localstorage)
            // 如果是meeting_webview或者navigator.userAgent.match("app/tencent_wemeet") && store.getters.statApiToken则使用state中的apiToken登录
            const shouldUseApiToken = () => {
                return (type == MEETING_WEBVIEW) || (navigator.userAgent.match("app/tencent_wemeet")) && store.getters.statApiToken;
            };
            const apiToken = shouldUseApiToken() ? store.getters.statApiToken : store.getters.apiToken;
            if (to.meta.requiresAuth && (!apiToken || type == MEETING_WEBVIEW_TAPD_LOGIN)) {
                // HARD CODE FIX
                let code = to.query.code;
                if (!code) {
                    let hash = to.hash || '';
                    let [, codeInhash] = hash.match(/code=(.*?)&/) || [];
                    code = codeInhash;
                }

                let query = {
                    redirect: to.path,
                    code: code,
                    resource: to.query.resource,
                    type
                };
                // console.log('to',JSON.stringify(to));
                // console.log(path);
                // console.log('query', JSON.stringify(query));
                next({ path, query })
            } else {
                next()
            }
        }else{
            //内网环境下用太湖登录，禁用apiToken判断，有没有登录态看store.getters.userInfo
            // console.log('---------------');
            // console.log(type);
            // console.log(path);
            // console.log(to);
            // console.log(from);
            // console.log('---------------');
            if (to.meta.requiresAuth && (!store.getters.userInfo || type == MEETING_WEBVIEW_TAPD_LOGIN)) {
                // HARD CODE FIX
                let code = to.query.code;
                if (!code) {
                    let hash = to.hash || '';
                    let [, codeInhash] = hash.match(/code=(.*?)&/) || [];
                    code = codeInhash;
                }                
                next({ path, query: { 
                    redirect: to.path,
                    code: code,
                    resource: to.query.resource,
                    type: type
                 } })
            } else {
                next()
            }


        }


    }
});

router.afterEach(() => {
    sendMessage("routeChange", { "url": location.href });
});

export default router
